<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted () {
    if (this._isMobile()) {
      console.log('手机端')
    } else {
      console.log('pc端');
      //跳转pc端地址
      window.location.href = 'https://www.zhongdaokj.com'
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue